import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"
import userReducers from "../reducers"

/* Save a guest account with an address and a password (and, optionally, a name of their own). The
   same row on the server, so nothing else in the client changes but the account's own fields.
   `handlesOwnErrors`: the form prints the refusal against its fields. */
export const thunk = createAsyncThunk("user/claimGuest", async (data, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/users/me/save-guest/", data, { handlesOwnErrors: true })
    return {
      username: response.data.username,
      email: response.data.email,
      hasPassword: response.data.has_password,
      isGuest: Boolean(response.data.is_guest),
    }
  } catch (error) {
    return rejectWithValue(error.response?.data || { detail: "Could not reach the server." })
  }
})

export const onSucceed = userReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
